import script from "./QuotationSuggestions.vue?vue&type=script&lang=js"
export * from "./QuotationSuggestions.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__